// Module
var code = "<div class=dashboard> <dashboard-presentation></dashboard-presentation> <dashboard-filters ng-hide=model.isFullscreen></dashboard-filters> <div class=divider ng-hide=model.isFullscreen></div> <dashboard-content></dashboard-content> </div> ";
// Exports
module.exports = code;